export const SERVER_PATH = import.meta.env.VITE_APP_API_URL;

// Auth End Points
export const AUTH_URL = `${SERVER_PATH}/api/users`;

// Organization End Points
export const ORGANIZATION_URL = `${SERVER_PATH}/api/organizations`;

// Employee End Points
export const EMPLOYEE_URL = `${SERVER_PATH}/api/employees/organization`;

// Chat End Points
export const CHAT_URL = `${SERVER_PATH}/api/chat`;

// Plan End Points
export const PLAN_URL = `${SERVER_PATH}/api/plans`;

// User End Points
export const USER_URL = `${SERVER_PATH}/api/users`;

// Model End Points
export const MODEL_URL = `${SERVER_PATH}/api/models`;

// Model Types End Points
export const MODEL_TYPES_URL = `${SERVER_PATH}/api/model-types`;

// Sources End Points
export const SOURCES_URL = `${SERVER_PATH}/api/sources`;

// Usage End Points
export const USAGE_URL = `${SERVER_PATH}/api/usage`;

// Payment End Points
export const PAYMENT_URL = `${SERVER_PATH}/api/payments`;

// Subscription End Points
export const SUBSCRIPTION_URL = `${SERVER_PATH}/api/subscriptions`;

// Partner End Points
export const PARTNER_URL = `${SERVER_PATH}/api/partners/partners`;

// Referral End Points
export const REFERRAL_URL = `${SERVER_PATH}/api/referrals`;

// Persona End Points
export const PERSONA_URL = `${SERVER_PATH}/api/personas`;

// Newsletter End Points
export const NEWSLETTER_URL = `${SERVER_PATH}/api/admin/newsletter`;

// Create User Manually End Point
export const USER_CREATE_MANUAL = `${SERVER_PATH}/api/admin/users`;
